import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./KycSubmitted.scss";
import ImageCheckmarkCircleGreen from "../../../images/checkmark-circle-green.svg";
import { ROUTES, usePlayGameMetaDescription } from "../../../utils/constants";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../../utils/renderHeaders";

const REDIRECT_SECONDS = 3;

export default function KycSubmitted() {
  const navigate = useNavigate();
  const { t } = useTranslation("kyc");
  const metaDescriptions = usePlayGameMetaDescription();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    const intervalId = setInterval(
      () => setSecondsLeft((prev) => (prev <= 1 ? 0 : prev - 1)),
      1000
    );
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (secondsLeft === 0) {
      navigate(ROUTES.ROOT.HOME);
    }
  }, [secondsLeft, navigate]);

  return (
    <>
      {renderHeaders({
        title: t("metadata:kyc_verification_submitted_hyper_gaming_app"),
        description: metaDescriptions.generic,
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:kyc_verification_submitted_hyper_gaming_app")
        ),
      })}

      <div className="KycSubmitted">
        <div className="MainContent">
          <Image
            src={ImageCheckmarkCircleGreen}
            alt=""
            className="KycIcon"
            width={64}
            height={64}
          />
          <h1 className="Title">{t("verification_request_submitted")}</h1>
          <p className="Subtitle">
            {t("weve_received_your_verification_request")}
          </p>
        </div>

        <p className="RedirectingText">
          {t("redirecting")} <span className="Seconds">{secondsLeft}s</span>
        </p>
      </div>
    </>
  );
}
